<template>
  <div>
    <form-build
      form-name="editForm"
      :form-data.sync="data"
      :form-rules="editFormRules"
      :form-columns-group="editFormColumnsGroup"
      :form-buttons="editFormButtons"
    >
    </form-build>
  </div>
</template>

<script>
  import FormBuild from '../../components/FormBuild'
  import { provinceAndCityData, CodeToText } from 'element-china-area-data'
  import sexOptions from '../../utils/sexOptions'

  export default {
    name: "CompanyEditComponent",
    data() {
      return {
        editFormRules: {
          "mobileNo": [
            {
              required: true,
              message: '手机号不能为空'
            },
            {
              type: 'number',
              message: '请输入11位数字的手机号'
            }
          ],
          c__customerName: [
            {
              required: true,
              message: '企业名称不能为空！'
            }
          ],
          i__socialIdentityCode: [
            {
              required: true,
              message: '统一社会信用代码不能为空！'
            }
          ],
          i__provinceAndCity: [
            {
              required: true,
              message: '单位所在地不能为空！'
            }
          ],
          i__bizrep: [
            {
              required: true,
              message: '法人姓名不能为空！'
            }
          ],
          i__contactPerson:[
            {
              required: true,
              message: '联系人不能为空！'
            }
          ],
          i__contactTelNo: [
            {
              required: true,
              message: '联系人手机号不能为空！'
            }
          ],
        },

        editFormColumnsGroup: [
          {
            label: '企业信息',
            columns: [
              {
                label: '企业名称',
                component: 'el-input',
                field: 'c__customerName',
              },
              {
                label: '统一社会信用代码',
                component: 'el-input',
                field: 'i__socialIdentityCode'
              },
              {
                label: '单位所在地',
                component: 'el-cascader',
                field: 'i__provinceAndCity',
                options: provinceAndCityData,
              },
              {
                label: '营业期限',
                component: 'date-range-picker',
                field: 'i__bizlicValidity',
                valueFormat: "yyyy-MM-dd"
              },
              {
                label: '住所',
                component: 'el-input',
                field: 'i__address',
                span: 24
              }
            ]
          },
          {
            label: '法人信息',
            columns: [
              {
                label: '法人姓名',
                component: 'el-input',
                field: 'i__bizrep'
              },
              {
                label: '证件类型',
                component: 'el-select',
                options: [
                  {
                    label: '身份证',
                    key: '身份证',
                    value: '身份证'
                  },
                  {
                    label: '护照',
                    key: '护照',
                    value: '护照'
                  },
                  {
                    label: '台胞证',
                    key: '台胞证',
                    value: '台胞证'
                  }
                ],
                field: 'i__bizrepType'
              },
              {
                label: '手机号',
                component: 'el-input',
                field: 'i__bizrepMobile'
              },
              {
                label: '证件号码',
                component: 'el-input',
                field: 'i__bizrepIC'
              },
              {
                label: '证件有效期',
                component: 'date-range-picker',
                type: 'daterange',
                field: 'i__bizrepICValidity',
                valueFormat: "yyyy-MM-dd"
              },
            ]
          },
          {
            label: '联系人信息',
            columns: [
              {
                label: '姓名',
                component: 'el-input',
                field: 'i__contactPerson'
              },
              {
                label: '性别',
                component: 'el-select',
                field: 'i__contactSex',
                options: sexOptions
              },
              {
                label: '手机号',
                component: 'el-input',
                field: 'i__contactTelNo'
              },
              {
                label: '固定电话',
                component: 'el-input',
                field: 'i__contactTelNo2'
              },
              {
                label: '邮箱',
                component: 'el-input',
                field: 'i__contactEmail'
              },
              {
                label: '传真',
                component: 'el-input',
                field: 'i__contactFaxNo'
              }
            ]
          },
          {
            label: '证件信息',
            columns: [
              {
                label: '营业执照',
                component: 'image-upload',
                field: 'i__bizlicURL',
                span: 24,
              },
              {
                label: '法人证件照头像页',
                component: 'image-upload',
                field: 'i__bizrepICURL1',
                span: 24
              },
              {
                label: '法人证件照国徽页',
                component: 'image-upload',
                field: 'i__bizrepICURL2',
                span: 24
              }
            ]
          }
        ],
        editFormButtons: [
          {
            label: '确认',
            type: 'primary',
            clickHandler: ($refs)=>{
              this.$emit('onSubmit', $refs)
            }
          },
          {
            label: '重置',
            clickHandler: ($refs)=>{
              $refs.resetFields()
            }
          }
        ]
      }
    },
    components: {
      FormBuild
    },
    props: {
      data: {
        type: Object,
        default: () => {
          return {
            "u__email": "",
            "c__customerName": "",
            "c__customerCode": "",
            "i__provinceAndCity": [],
            // "i__province": "",
            // "i__city": "",
            "i__address": "",
            "i__socialIdentityCode": "",
            "i__registeredCapital": "",
            "i__bizlicValidity": [],
            // "i__bizlicValidity1": "",
            // "i__bizlicValidity2": "",
            "i__bizlicURL": "",
            "i__contactPerson": "",
            "i__contactSex": "",
            "i__contactTelNo": "",
            "i__contactTelNo2": "",
            "i__contactFaxNo": "",
            "i__contactEmail": "",
            "i__industry": "",
            "i__bizrep": "",
            "i__bizrepIC": "",
            "i__bizrepICValidity": [],
            // "i__bizrepICValidity1": "",
            // "i__bizrepICValidity2": "",
            "i__bizrepLocation": "",
            "i__bizrepICURL1": "",
            "i__bizrepICURL2": "",
            "i__bizrepICURL3": "",
            "i__remarks": ""
          }
        }
      },
    },
    watch: {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/CompanyEditComponent.vue